import { proxy } from "valtio";

/*
    Fired by item UIs after any mutation that can change setup-status
    (member added, contract linked, audience created, ...). The engagement
    detail page listens and refetches setup-status.
*/
const baseEventCounts = {
  WORKFLOW_DATA_TOUCHED: 0,
} as const;

type WorkflowEventKeys = keyof typeof baseEventCounts;

export const workflowEvents = proxy({
  ...baseEventCounts,
  send_event(this: any, key: WorkflowEventKeys) {
    this[key] += 1;
  },
});
